<template>
  <div>
    <HearderTitle name="查看详情" />
    <div class="main">
      <el-card shadow="always">
        <div slot="header" class="clearfix">
          <img src="../../assets/images/name-img.png" alt="" />
          <div class="info">
            <h3>{{ personnelInfo.pername }}</h3>
            <div>
              <span>全职</span>
              <i>|</i>
              <span>外线员工</span>
              <i>|</i>
              <span>{{ personnelInfo.contact }}</span>
            </div>
          </div>
          <div class="content">
            <ul>
              <li>
                <span>所属部门</span><i>{{ personnelInfo.dep_id }}</i>
              </li>
              <li>
                <span>职务</span><i>{{ personnelInfo.roles }}</i>
              </li>
              <li><span>状态</span><i style="color: #ff6f20">外线员工</i></li>
              <li>
                <span>学历</span><i>{{ personnelInfo.edu }}</i>
              </li>
              <li>
                <span>专业</span><i>{{ personnelInfo.manjor }}</i>
              </li>
              <li>
                <span>联系方式</span><i>{{ personnelInfo.contact }}</i>
              </li>
            </ul>
          </div>
        </div>
      </el-card>
      <el-card class="mt20 card2" shadow="always">
        <el-divider class="divider" content-position="left">入职信息</el-divider>
        <div class="info">
          <ul>
            <li>
              <span>性别</span><i>{{ personnelInfo.sex }}</i>
            </li>
            <li>
              <span>民族</span><i>{{ personnelInfo.nation }}</i>
            </li>
            <li>
              <span>婚姻状态</span><i>{{ personnelInfo.marrage }}</i>
            </li>
            <li>
              <span>学校</span><i>{{ personnelInfo.school }}</i>
            </li>
            <li>
              <span>生日</span><i>{{ personnelInfo.birthday }}</i>
            </li>
            <li>
              <span>入职时间</span><i>{{ personnelInfo.inday }}</i>
            </li>
            <li>
              <span>司龄</span><i>{{ personnelInfo.inday | dateSubMonth }}</i>
            </li>
            <li>
              <span>身份证号</span><i>{{ personnelInfo.cardid }}</i>
            </li>
            <li>
              <span>户籍</span><i>{{ personnelInfo.province }}</i>
            </li>
            <li>
              <span>户籍所在地</span><i>{{ personnelInfo.address }}</i>
            </li>

            <li>
              <span>面试人</span><i>{{ personnelInfo.msper }}</i>
            </li>
            <li>
              <span>面试评价</span><i>{{ personnelInfo.mspj }}</i>
            </li>
            <li>
              <span>备注</span><i>{{ personnelInfo.moreinfo }}</i>
            </li>
          </ul>
        </div>
        <el-divider class="divider" content-position="left">简历图片</el-divider>
        <div class="imgbox">
          <a v-for="item in picList" :key="item" href="javascript:;"><el-image style="width: 126px; height: 168px" :src="item" :preview-src-list="[item]"> </el-image></a>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
  import { getOutsourcingInfoById } from '@/api/personnelList.js'
  import HearderTitle from '@/components/HearderTitle'
  import { dateSubMonth } from '@/util'

  export default {
    name: 'personnelDetail',
    data() {
      return {
        personnelInfo: {},
      }
    },
    created() {
      let id = ''
      if (this.$route.params.id) {
        id = this.$route.params.id
        sessionStorage.setItem('personneId', id)
      } else {
        id = JSON.parse(sessionStorage.getItem('personneId'))
      }
      this.getOutsourcingInfoById(id)
    },
    methods: {
      // 根据id查询人员信息
      async getOutsourcingInfoById(id) {
        let res = await getOutsourcingInfoById({ id })
        this.personnelInfo = res.data
      },
    },
    components: { HearderTitle },
    computed: {
      status: {
        get() {
          const arr = ['', '试岗期', '试用期', '正式员工']
          return arr[this.personnelInfo.stu]
        },
      },
      picList: {
        get() {
          if (!this.personnelInfo.pics) return []
          let arr = this.personnelInfo.pics.split(',').reverse()
          return arr
        },
      },
    },
    filters: {
      // 计算入职时间
      dateSubMonth(date) {
        return dateSubMonth(date)
      },
    },
  }
</script>

<style lang="less">
  .main {
    width: 1030px;
    margin: 0 auto;
    padding-top: 35px;
    .clearfix {
      display: flex;
      padding-top: 10px;
      padding-left: 20px;
      padding-bottom: 10px;
      align-items: center;

      img {
        margin-right: 24px;
      }
      .info {
        color: #333333;
        > div {
          height: 12px;
          font-size: 12px;
          line-height: 12px;
          display: flex;
          align-items: center;
          i {
            padding: 0 10px;
          }
        }
        h3 {
          font-size: 24px;
          font-weight: normal;
          margin-bottom: 10px;
        }
        span {
          font-size: 12px;
          &:last-child {
            color: #015293;
          }
        }
      }
    }
    .el-card__body {
      padding: 0;
    }
    .content {
      flex: 1;
      min-width: 0;
      margin-left: 84px;
      padding-top: 52px;
      padding-right: 45px;
      ul {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        font-size: 12px;
        color: #333333;
        flex-wrap: wrap;
        li {
          width: 33.33%;
          margin-bottom: 26px;
          span {
            margin-right: 10px;
          }
          i {
            color: #015293;
          }
        }
      }
    }
    .card2 {
      padding-left: 40px;
      margin-bottom: 30px;
      .divider {
        margin-bottom: 30px;
        font-size: 14px;
        .el-divider__text {
          line-height: 14px;
          height: 14px;
          padding: 1px 10px;
        }
        .is-left {
          left: 0;
          border-left: 3px solid #1f7ac3;
        }
      }
      .info {
        ul {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          li {
            width: 50%;
            text-align: left;
            font-size: 12px;
            color: #333333;
            margin-bottom: 20px;
            &:nth-child(2n + 1) {
              padding-left: 80px;
            }
            &:nth-child(2n) {
              padding-left: 95px;
            }
            &:nth-last-of-type(-n + 2) {
              width: 100%;
              text-align: left;
              padding-left: 80px;
            }
            span {
              margin-right: 18px;
              display: inline-block;
              width: 100px;
              text-align: right;
            }
            i {
              display: inline-block;
              width: 67%;
              text-align: left;
              color: #015293;
            }
          }
        }
      }
      .imgbox {
        padding-left: 100px;
        min-height: 48px;
        a {
          display: inline-block;
          width: 126px;

          margin-right: 30px;
          margin-bottom: 5px;
          height: 168px;
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
</style>
